var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5V25.5C33 31.5 31.5 33 25.5 33H10.5C4.5 33 3 31.5 3 25.5V10.5C3 4.5 4.5 3 10.5 3H12.75C15 3 15.495 3.66 16.35 4.8L18.6 7.8C19.17 8.55 19.5 9 21 9H25.5C31.5 9 33 10.5 33 16.5Z",
    stroke: "#343A40",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H25.5C28.5 3 30 4.5 30 7.5V9.57",
    stroke: "#343A40",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder2);
export default __webpack_public_path__ + "static/media/folder-2.777441d151a9f12860add6844c0ade42.svg";
export { ForwardRef as ReactComponent };